import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { OrdersViewComp } from "./component";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";
import { setLoading } from "../OrdersList/actions";
import ClipboardJS from "clipboard";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const OrdersViewContainer = (props) => {
  const { orderid } = useParams();

  const [orderData, setOrderData] = useState();
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [issue, setIssue] = useState("");
  const [orderStatus, setOrderStatus] = useState([])
  const [selectedIssue, setSelectedIssue] = useState("");
  const [refundId, setRefundId] = useState('')
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();


  useEffect(() => {
    LoadOrderView();
  }, []);

  const handleIssueChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedIssue(selectedValue);

    if (selectedValue !== "other") {

      setIssue(selectedValue);
    }
  };

  const handleIssueTextChange = (event) => {

    setIssue(event.target.value);
  };

  const LoadOrderView = () => {
    setLoading(true);

    return props.getDataFromAPI(
      `/partner/api/v1/admin/orders/${orderid}`,
      "GET",
      undefined,
      (response) => {
        setLoading(false);
        setOrderData(response);

        if (response.refund_details && response.refund_details.length > 0) {
          const firstRefundId = response.refund_details[0].id;
          setRefundId(firstRefundId);
        }
      },
      (err) => {
        setLoading(false);
        toastr.error(`${err?.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });

      },
      true
    );
  };



  const handleSubmit = () => {
    if (orderData && orderData.id && orderData.status && orderData.created_at && issue) {
      const { id, status, created_at, phone } = orderData;
      const name = localStorage.data
        ? JSON.parse(localStorage.data).details.userDetails.full_name
        : 'N/A';

      const phoneValue = phone ? phone : 'N/A';

      const utcTime = orderData && orderData.created_at;
      const utcDate = new Date(utcTime);

      const istTimeOptions = { timeZone: 'Asia/Kolkata', hour12: true };
      const istTimeString = utcDate.toLocaleString('en', istTimeOptions);



      const orderText = `${id}\t${status}\t${istTimeString}\t${phoneValue}\t${issue}\t${name}`;

      navigator.clipboard
        .writeText(orderText)
        .then(() => {

          setShow(false);
        })
        .catch((error) => {

        });
    }
  };

  const handleCopyInfo = () => {

    if (orderData && orderData.machine_id && orderData.city && orderData.name && orderData.vmAddress) {
      const { machine_id, city, created_at, vmAddress, name } = orderData;

      const utcTime = orderData && orderData.created_at;
      const utcDate = new Date(utcTime);

      const istTimeOptions = { timeZone: 'Asia/Kolkata', hour12: true };
      const istTimeString = utcDate.toLocaleString('en', istTimeOptions);



      const orderText = `${machine_id}\t${city}\t${name}\t${vmAddress}`;

      navigator.clipboard
        .writeText(orderText)
        .then(() => {

          setShow(false);
        })
        .catch((error) => {

        });
    }
  };

  
  const fetchOrderStatus = () => {
    setLoading(true); 
  
    return props.getDataFromAPI(
      `/partner/api/v2/payment/refund/${orderid}/status`,
      "GET",
      undefined,
      (response) => {
        setOrderStatus(response);
        setLoading(false); 
      },
      (err) => {
        setLoading(false);
        toastr.error(`${err?.response?.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      },
      true
    );
  };
  

  console.log("order refund status", orderData)

  return (
    <>
      <OrdersViewComp
        data={orderData}
        loading={loading}
        show={show}
        handleClose={handleClose}
        handleShow={handleShow}
        handleSubmit={handleSubmit}
        handleIssueChange={handleIssueChange}
        selectedIssue={selectedIssue}
        handleIssueTextChange={handleIssueTextChange}
        handleCopyInfo={handleCopyInfo}
        orderStatus={orderStatus}
        fetchOrderStatus={fetchOrderStatus}
      />

    </>
  );
};

function mapStateToProps({ props }) {
  return {
    props,
  };
}
export default connect(mapStateToProps, {
  getDataFromAPI,
  setLoading,
})(OrdersViewContainer);
